// Material Kit 2 React pages
import Alumni from "pages/Alumni";

export default function AlumniPage() {
  return <Alumni />;
}
